import {isNullOrUndefined} from "../../../../services/Validator";

export default function ExerciserContentLayout({children}) {
    // Used in MetaExerciserScreen and PreviewExerciserManager
    // to meta frame exerciser

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"grow w-full sm:w-[584px] sm:max-w-[584px] md:w-[640px] md:max-w-[640px] lg:w-[768px] lg:max-w-[768px] flex flex-col justify-start items-center"}>
            {children}
        </div>
    );
}